import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance.js";
import { MdDeleteForever } from "react-icons/md";
import { KanbanBoard } from "../../common/KanbanBoard/index.jsx";
import CloseWonModal from "./CloseWonModel.js";
import CloseLostModal from "./CloseLostModel.js";
import Loader from "../../common/Loader/index.js";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { BiSolidEditAlt } from "react-icons/bi";
import { RiFilter2Fill } from "react-icons/ri";
import { notify, Toast } from "../../common/Toast/index.js";
import Model from "../../common/Model/index.js";
import formatDateIndian from "../../common/formatDateIndian.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import Filter from "../../common/Filter/index.js";
import InProductionModel from "./InProductionModel.js";
import { IoCalendarClearOutline, IoPerson } from "react-icons/io5";

const stageMapping = {
  1: "Active",
  2: "Close Won",
  3: "Close Lost",
  6: "In-Production",
  7: "Complete",
};

const stageID = {
  Active: 1,
  "Close Won": 2,
  "Close Lost": 3,
  "In-Production": 6,
  Complete: 7,
};

const WindowQuotation = () => {
  const permission = getUserMenuPermission(8);
  const navigate = useNavigate();
  const [isWindowData, setIsWindowData] = useState([]);
  const [owners, setOwners] = useState({});
  const [sites, setSites] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isCloseLostModalOpen, setIsCloseLostModalOpen] = useState(false);
  const [isInProductionModelOpen, setIsInProductionModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openMenuCard, setOpenMenuCard] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterBtnRef = useRef(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [salePersons, setSalePersons] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    quotationNo: "",
    siteName: "",
    ownerName: "",
    salePerson: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    quotationNo: "",
    siteName: "",
    ownerName: "",
    salePerson: "",
  });
  const userId = localStorage.getItem("userId");
  const location = useLocation();
  const filteredData = location?.state?.filteredData || [];
  const isFilteredFromDashboard =
    location.state?.isFilteredFromDashboard || false;
  const [initialized, setInitialized] = useState(false);
  const [formData, setFormData] = useState({
    quotation_No: "",
    final_Amount: "",
    final_Profile_Color: "",
    glass_Color_Type: "",
    work_Complete_Date: "",
  });
  useEffect(() => {
    if (!initialized) {
      if (
        location.state?.isFilteredFromDashboard &&
        Array.isArray(location.state?.filteredData)
      ) {
        const transformed = filteredData?.map((item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "window-quotation",
        }));
        setIsWindowData(transformed);
        setLoading(false);
      } else {
        fetchData();
      }
      setInitialized(true);
    }
  }, [initialized, location.state]);

  const toggleMenu = (quotationNo) => {
    setOpenMenuCard((prev) => (prev === quotationNo ? null : quotationNo));
  };

  useEffect(() => {
    const fetchSitesAndOwners = async () => {
      try {
        const [sitesRes, ownersRes] = await Promise.all([
          axiosInstance.get("SiteDetail/GetAll"),
          axiosInstance.get("Owner/GetAll"),
        ]);
        const siteMap = (sitesRes.data || []).reduce((acc, site) => {
          acc[site.site_Id] = site.site_Name;
          return acc;
        }, {});
        setSites(siteMap);

        const ownerMap = (ownersRes.data || []).reduce((acc, owner) => {
          acc[owner.owner_ID] = owner.owner_Name;
          return acc;
        }, {});
        setOwners(ownerMap);
      } catch (err) {
        console.error("Error fetching sites/owners:", err);
      }
    };
    fetchSitesAndOwners();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenuCard(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // const handleCardMove = (card, newStage, oldStageId) => {
  //   const currentStageID = Number(oldStageId);
  //   const newStageID = stageID[newStage];

  //   if (currentStageID === 1 && (newStageID === 2 || newStageID === 3)) {
  //     setSelectedCard(card);
  //     newStageID === 2 ? setIsModalOpen(true) : setIsCloseLostModalOpen(true);
  //   } else if (currentStageID === 2) {
  //     setSelectedCard(card);
  //     if (newStageID === 6) {
  //       handleUpdateStage(card, newStage);
  //     } else if (newStageID === 3) {
  //       setIsCloseLostModalOpen(true);
  //     }
  //   } else if (currentStageID === 6 && newStageID === 7) {
  //     handleUpdateStage(card, newStage);
  //   } else if (currentStageID === 7) {
  //     notify("Cannot move cards from Complete stage.");
  //   } else if (currentStageID === 3 && newStageID === 1) {
  //     handleUpdateStage(card, newStage);
  //   } else {
  //     notify(
  //       `Invalid move from ${stageMapping[currentStageID]} to ${stageMapping[newStageID]}`
  //     );
  //   }
  // };

  const handleCardMove = (card, newStage, oldStageId) => {
    const currentStageID = Number(oldStageId);
    const newStageID = stageID[newStage];

    if (currentStageID === 1 && (newStageID === 2 || newStageID === 3)) {
      setSelectedCard(card);
      newStageID === 2 ? setIsModalOpen(true) : setIsCloseLostModalOpen(true);
    } else if (currentStageID === 2) {
      setSelectedCard(card);
      if (newStageID === 6) {
        setIsInProductionModalOpen(true);
      } else if (newStageID === 3) {
        setIsCloseLostModalOpen(true);
      }
    } else if (currentStageID === 6 && newStageID === 7) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 7) {
      notify("Cannot move cards from Complete stage.");
    } else if (currentStageID === 3 && newStageID === 1) {
      handleUpdateStage(card, newStage);
    } else {
      notify(
        `Invalid move from ${stageMapping[currentStageID]} to ${stageMapping[newStageID]}`
      );
    }
  };

  const handleUpdateStage = async (card, newStage) => {
    try {
      setLoading(true);
      await axiosInstance.post("WindowQuotation/AllUpdateQuotationStage", {
        quotation_No: card,
        stage_Id: stageID[newStage],
      });
      notify("successfully updating stage:", "success");
      fetchData();
    } catch (error) {
      notify("Error updating stage:", error);
    }
    setLoading(false);
  };

  const handleCloseWonSave = async () => {
    const payload = {
      quotation_No: selectedCard,
      site_Id: selectedCard,
      work_Complete_Date: formData.work_Complete_Date ? new Date(formData.work_Complete_Date).toISOString() : null,
      final_Amount: (formData.final_Amount && !isNaN(formData.final_Amount)) ? parseFloat(formData.final_Amount) : null,
      final_Profile_Color: formData.final_Profile_Color,
      glass_Color_Type: formData.glass_Color_Type,
      created_By: userId,
    };
    try {
      setLoading(true);
      await axiosInstance.post("WindowQuotation/SaveCloseOwnWithFile", payload);
      fetchData();
      notify("successfully Close-Won stage:", "success");
    } catch (error) {
      notify("Error saving Close Won:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseLostSave = async (reason) => {
    try {
      setLoading(true);
      await axiosInstance.post("WindowQuotation/SaveCloseLost", {
        quotation_No: selectedCard,
        Reason: reason,
      });
      fetchData();
      notify("successfully Close-Lost stage:", "success");
    } catch (error) {
      notify("Error saving Close Lost:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleInproductionSave = async (file) => {
    if (!selectedCard) {
      notify("No card selected.", "error");
      return;
    }
    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("Quotation_No", String(selectedCard));
      fd.append("Site_Id", String(selectedCard));
      fd.append("Created_By", String(userId));
      fd.append("File_Upload", file);

      await axiosInstance.post("WindowQuotation/SaveInProductionWithFile", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      notify("Moved to In-Production with file.", "success");
      fetchData();
    } catch (error) {
      notify("Error moving to In-Production:", error);
    } finally {
      setLoading(false);
      setIsInProductionModalOpen(false);
      setSelectedCard(null);
    }
  };

  const columns = [
    "Active",
    "Close Won",
    "In-Production",
    "Complete",
    "Close Lost",
  ];

  const bgColors = [
    "bg-primary",
    "bg-warning",
    "bg-secondary",
    "bg-success",
    "bg-danger",
  ];

  useEffect(() => {
    const fetchSalePersons = async () => {
      try {
        const res = await axiosInstance.get("User/GetAllUser");
        const salesData = res.data.map((person) => ({
          sale_Person_Id: Number(person.sale_Person_Id),
          Sale_Person_Name: person.Sale_Person_Name,
        }));

        setSalePersons(salesData);
      } catch (error) {
        notify("Error fetching sale persons:", error);
      }
    };

    fetchSalePersons();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const hasFilters = Object.values(appliedFilters).some(
        (val) => val.trim() !== ""
      );

      const [windowDataResponse] =
        await Promise.all([
          axiosInstance.post("WindowQuotation/GetAllWindowQuotation", {
            PageNumber: 1,
            PageSize: 10,
            Quotation_No: appliedFilters.quotationNo
              ? parseInt(appliedFilters.quotationNo)
              : null,
            Site_ID: appliedFilters.siteName
              ? parseInt(appliedFilters.siteName)
              : null,
            owner_Name: appliedFilters.ownerName,
            sale_Person_Id: hasFilters
              ? appliedFilters.salePerson
                ? Number(appliedFilters.salePerson)
                : null
              : Number(userId),
          }),
        ]);
      const transformedData = windowDataResponse.data.quotations.map(
        (item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: item.type || "window-quotation",
        })
      );
      setIsWindowData(transformedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilteredFromDashboard) {
      fetchData();
    }
  }, [appliedFilters]);

  const handleEdit = async (quotationNo) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `WindowQuotation/GetWindowQuotationsWithFiles/${quotationNo}`
      );
      notify("WindowQuotation loaded for editing.", "success");
      navigate("/quotes/window-quotation/active-details", {
        state: { activeDetailsData: data },
      });
      fetchData();
    } catch (error) {
      notify("Error fetching WindowQuotation details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(`WindowQuotation/Delete/${selectedId}`);
      setAppliedFilters({ ...appliedFilters });
      notify("WindowQuotation deleted successfully!", "error");
    } catch (err) {
      notify("Error deleting error:", err);
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const renderCard = (card) => {
    const stageOptions = {
      1: ["Close Won", "Close Lost"],
      2: ["In-Production", "Close Lost"],
      6: ["Complete"],
      7: [],
      3: ["Active"],
    };
    const salePersonName =
      salePersons.find(
        (sp) => Number(sp.sale_Person_Id) === Number(card.sale_Person_Id)
      )?.Sale_Person_Name || "-";

    const getInitials = (name) => {
      if (!name) return "";
      const words = name.trim().split(" ");
      return words
        .slice(0, 2)
        .map((w) => w.charAt(0).toUpperCase())
        .join("");
    };

    const initials = getInitials(salePersonName);
    return (
      <div
        key={card.quotation_No}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData("cardId", card.quotation_No.toString());
          e.dataTransfer.setData("stageId", card.stage_Id.toString());
        }}
        className="group relative rounded-xl bg-white p-4 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 cursor-grab active:cursor-grabbing mb-1"
      >
        <div className="flex justify-between items-start mb-3">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span className="text-[13px] font-bold text-primary bg-primary/5 px-2 py-0.5 rounded-md">
                # {card.quotation_No}
              </span>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu(card.quotation_No);
            }}
            className="p-1.5 rounded-lg text-gray-400 hover:text-primary hover:bg-gray-50 transition-colors"
          >
            <HiOutlineDotsVertical className="w-4 h-4" />
          </button>
        </div>

        <div onClick={() => handleEdit(card.quotation_No)} className="cursor-pointer">
          <h4 className="text-[15px] font-bold text-gray-800 line-clamp-1 group-hover:text-primary transition-colors">
            {sites[card.site_Id] || "Site Name Not Found"}
          </h4>
          <p className="text-[13px] text-gray-500 font-medium">
            {owners[card.owner_ID] || "Owner Name Not Found"}
          </p>
          <p className="text-[13px] text-gray-500 font-medium">
            {salePersonName || "Sale Person Name Not Found"}
          </p>

          <div className="flex flex-col gap-1.5 mb-2">
            <div className="flex items-center justify-between">
              <span className="text-[14px] font-bold text-gray-900">
                ₹{Number(card.quote_Amount || 0).toLocaleString('en-IN')}
              </span>
              <span className="text-[12px] text-gray-500 font-medium bg-gray-50 px-2 py-0.5 rounded">
                {card.total_Sqft} Sq.Ft
              </span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-1 border-t border-gray-50">
            <div className="flex items-center gap-1.5 text-gray-500">
              <IoCalendarClearOutline className="w-3.5 h-3.5" />
              <span className="text-[12px] font-medium">
                {formatDateIndian(card.quotation_Date)}
              </span>
            </div>
            <div className="relative group/avatar">
              <div className="w-7 h-7 bg-primary rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-sm ring-2 ring-white">
                {initials}
              </div>
            </div>
          </div>
        </div>

        {openMenuCard === card.quotation_No && (
          <div className="absolute right-4 top-12 w-48 bg-white border border-gray-100 shadow-xl rounded-xl z-[9999] overflow-hidden py-1 animate-in fade-in slide-in-from-top-2 duration-200">
            {permission.isUpdate && (
              <button
                onClick={() => handleEdit(card.quotation_No)}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors"
              >
                <BiSolidEditAlt className="w-4 h-4" /> Edit Details
              </button>
            )}

            {permission.isDelete && (
              <button
                onClick={() => handleDelete(card.quotation_No)}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-red-600 hover:bg-red-50 transition-colors"
              >
                <MdDeleteForever className="w-4 h-4" /> Delete Quotation
              </button>
            )}

            {stageOptions[card.stage_Id]?.length > 0 && (
              <>
                <div className="h-px bg-gray-100 my-1" />
                <div className="px-4 py-1.5 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Move To</div>
                {stageOptions[card.stage_Id].map((option) => (
                  <button
                    key={option}
                    onClick={() => handleCardMove(card.quotation_No, option, card.stage_Id)}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-primary transition-colors"
                  >
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-300" />
                    {option}
                  </button>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const applyFilters = () => {
    setAppliedFilters({ ...filters });
    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    setFilters({
      quotationNo: "",
      siteName: "",
      CompanyName: "",
      salePerson: "",
    });
    setAppliedFilters({
      quotationNo: "",
      siteName: "",
      CompanyName: "",
      salePerson: "",
    });
  };

  const salePersonOptions = [
    ...salePersons.map((sp) => ({
      value: sp.sale_Person_Id.toString(),
      label: sp.Sale_Person_Name,
    })),
  ];
  const siteOptions = Object.entries(sites).map(([id, name]) => ({
    value: id,
    label: name,
  }));

  const filterFields = [
    {
      label: " Quotation No",
      name: "quotationNo",
      type: "number",
      placeholder: "Search Quotation No",
    },
    {
      label: "Sales Person",
      name: "salePerson",
      type: "select",
      options: salePersonOptions,
    },
    {
      label: "Owner Name",
      name: "ownerName",
      type: "text",
      placeholder: "Search Owner Name",
    },
    {
      label: "Site Name",
      name: "siteName",
      type: "select",
      options: siteOptions,
    },
  ];

  return (
    <>
      <Toast />
      <div>
        <div className="rounded-3xl bg-transparent px-2 pt-2 pb-6">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-9999">
              <Loader />
            </div>
          )}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">Window Quotation Pipeline</h2>
              <p className="text-sm text-gray-500 font-medium">Manage and track your window quotations across stages</p>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto">
              {permission.isInsert && (
                <button
                  className="flex-1 md:flex-none flex items-center justify-center gap-2 bg-primary hover:bg-primary/95 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg shadow-primary/20 transition-all active:scale-95"
                  onClick={() => navigate("/quotes/window-quotation/active-details")}
                >
                  <span>+</span> Add New Quotation
                </button>
              )}
              <button
                ref={filterBtnRef}
                className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 px-5 py-2.5 rounded-xl font-bold shadow-sm border border-gray-100 transition-all active:scale-95"
                onClick={() => setIsFilterOpen((prev) => !prev)}
              >
                <RiFilter2Fill className="text-lg text-primary" />
                <span>Filters</span>
              </button>
            </div>
          </div>

          <Filter
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
            filterFields={filterFields}
            filters={filters}
            setFilters={setFilters}
            applyFilters={applyFilters}
            clearFilters={clearFilters}
          />

          <div className="h-full">
            <KanbanBoard
              columns={columns}
              bgColors={bgColors}
              cards={isWindowData}
              onCardMove={handleCardMove}
              renderCard={renderCard}
            />
            <CloseWonModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSave={handleCloseWonSave}
              requiresFile={true}
              formData={formData}
              setFormData={setFormData}
            />
            <CloseLostModal
              isOpen={isCloseLostModalOpen}
              onClose={() => setIsCloseLostModalOpen(false)}
              onSave={handleCloseLostSave}
            />
            <InProductionModel
              isOpen={isInProductionModelOpen}
              onClose={() => setIsInProductionModalOpen(false)}
              onSave={handleInproductionSave}
            />
          </div>
        </div>
      </div>
      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <MdDeleteForever className="w-8 h-8" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Delete</h3>
          <p className="text-gray-500 mb-8 max-w-[300px] mx-auto">
            Are you sure you want to permanently delete this quotation? This action cannot be undone.
          </p>
          <div className="flex justify-center gap-3">
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-200 transition-all active:scale-95"
              onClick={handleConfirmDelete}
            >
              Delete Quotation
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default WindowQuotation;
